import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    // borderBottomColor: "#bff0fd",
    // borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    fontWeight: "bold",
  },
  title: {
    width: "50%",
    textAlign: "left",
    // borderRightColor: borderColor,
    // borderRightWidth: 1,
    paddingLeft: 8,
  },
  bez: {
    width: "10%",
    // borderRightColor: borderColor,
    // borderRightWidth: 1,
    textAlign: "right",
    paddingRight: 8,
  },
  bezimage: {
    width: "20pt",
    height: "8pt",
    //width: 25,
  },
  unit: {
    width: "10%",
    // borderRightColor: borderColor,
    // borderRightWidth: 1,
    textAlign: "left",
  },
  value: {
    width: "10%",
    // borderRightColor: borderColor,
    // borderRightWidth: 1,
    textAlign: "left",
  },
  formula: {
    width: "20%",
    textAlign: "right",
    //paddingRight: 8,
  },
  formulaimage: {
    height: 7,
    textAlign: "right",
    paddingRight: 10,
  },
});

function InvoiceTableBlankSpace({ rowsCount }) {
  const blankRows = Array(rowsCount).fill(0);
  const rows = blankRows.map((x, i) => (
    <View style={styles.row} key={`BR${i}`}>
      <Text style={styles.title}></Text>
      <Text style={styles.bez}></Text>
      <Text style={styles.value}></Text>
      <Text style={styles.unit}></Text>
      <Text style={styles.formula}></Text>
    </View>
  ));
  return <Fragment>{rows}</Fragment>;
}

export default InvoiceTableBlankSpace;
